import script from "./MyAITasks.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAITasks.vue?vue&type=script&setup=true&lang=js"

import "./MyAITasks.vue?vue&type=style&index=0&id=3de36860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de36860"]])

export default __exports__